import {
  BaseTemplate,
  OfflineBanner,
  useAuthenticatedUser,
  useTitlePrefix,
} from '@airship-platform/airship-patterns';
import { useOrganizationBusinessUnits } from '@airship-platform/airship-proposal';
import { useEffect } from 'react';
import { useOfflineDbStatus } from '../../data-offline';
import ROUTE_PATHS from '../../routes/paths';

const OfflineLeadershipTitlePrefix: React.FC = () => {
  const setTitlePrefix = useTitlePrefix();
  const snapshot = useOfflineDbStatus();

  useEffect(() => {
    setTitlePrefix(snapshot.leadership === 'leader' ? '👑' : '');

    return () => {
      setTitlePrefix('');
    };
  }, [snapshot.leadership, setTitlePrefix]);

  return null;
};

const BaseTemplateAuth: React.FC = () => {
  const { user, fetchUser } = useAuthenticatedUser();
  const { fetchOrganizationBusinessUnits } = useOrganizationBusinessUnits();

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  useEffect(() => {
    if (user?.organizationId) {
      fetchOrganizationBusinessUnits(user.organizationId);
    }
  }, [user?.organizationId, fetchOrganizationBusinessUnits]);

  return (
    <BaseTemplate
      additionalBanner={
        <>
          <OfflineLeadershipTitlePrefix />
          <OfflineBanner linkPath={ROUTE_PATHS.OFFLINE_DIAGNOSTICS} />
        </>
      }
    />
  );
};

export default BaseTemplateAuth;
